module.exports = __webpack_public_path__ + "e20dc1d8dea728076084b8fddf0ad77d.png";